import constants from "constants";

import {
  ADD_ADMIN_DASHBOARD_USERS,
  ADD_ADMIN_USERS,
  ADD_ADMIN_USERS_NEWSLETTER_WEBINARS,
  ADD_ADMIN_USRES_WEBINARS,
  ADD_ADMIN_USRES_WEBINARS_SESSIONS,
  ADD_ASSIGNED_USERS,
  ADD_CONFIRMATION_USERS,
  ADD_NOVONORDISK_USERS,
  // CLEAR_SPONSORS_REPRESENTATIVE_REQUESTS,
  PERFORM_LOGOUT,
  SET_EDIT_USER,
  SET_PROFILE_CONFIRMATION,
  // SET_SPONSORS_REPRESENTATIVE,
  // SET_SPONSORS_REPRESENTATIVE_REQUESTS,
  UPDATE_USER,
  UPDATE_USER_NOVONORDISK,
} from "constants/actions.js";
import {
  ADMIN_CLEAR_CERTIFICATES_USERS,
  ADMIN_SET_CERTIFICATES_USERS,
  CLEAR_NOTIFICATIONS,
  SET_NOTIFICATIONS,
  SET_NOTIFICATIONS_COUNT,
  SET_NOTIFICATIONS_INFINITE,
} from "../constants/actions";

const { ZOOM_INFO_STATUS } = constants;

const users = (
  users = {
    user: {},
    showProfileConfirmation: ZOOM_INFO_STATUS.closed,
    adminUsers: {
      values: [],
      page: 1,
      count: 0,
      total_pages: 0,
      query: {
        order: {
          created_at: "desc",
        },
      },
    },
    assignedUsers: {
      values: [],
      page: 1,
      count: 0,
      total_pages: 0,
      query: {
        order: {
          created_at: "desc",
        },
      },
    },
    confirmationUsers: {
      values: [],
      page: 1,
      count: 0,
      total_pages: 0,
      query: {
        order: {
          created_at: "desc",
        },
      },
    },
    adminWebinarRegisteredUsers: [],
    // novonordiskUsers: [],
    newsletters: {
      values: [],
      count: 0,
      total_pages: 0,
    },

    tmp: {},
    statistics: {
      registered_users: 0,
      logged_in_users: 0,
      user_type_users: 0,
      hospital_users: 0,
      county_users: 0,
      total_users: 0,
    },
    sessions: [],
    // sponsorRepresantive: {
    //   data: [],
    // },
    // sponsorRepresantiveRequests: {
    //   data: [],
    // },
    certificatesUsers: {
      data: [],
    },
    notifications: {
      data: [],
    },
    notificationsCount: 0,
  },
  { type, payload, page, pages }
) => {
  switch (type) {
    case UPDATE_USER:
      return { ...users, ...{ user: payload.user } };
    case UPDATE_USER_NOVONORDISK:
      return { ...users, ...{ user: payload.user } };
    case ADD_ADMIN_USERS:
      return {
        ...users,
        ...{
          adminUsers: {
            values: payload.values,
            count: payload.count,
            page: payload.page,
            total_pages: payload.total_pages,
            query: payload.query,
          },
        },
      };
    case ADD_CONFIRMATION_USERS:
      return {
        ...users,
        ...{
          confirmationUsers: {
            values: payload.values,
            count: payload.count,
            page: payload.page,
            total_pages: payload.total_pages,
            query: payload.query,
          },
        },
      };
    case PERFORM_LOGOUT:
      return {
        ...users,
        ...{ user: {} },
      };
    case SET_EDIT_USER:
      return {
        ...users,
        ...{
          tmp: payload.user,
        },
      };
    case ADD_ASSIGNED_USERS:
      return {
        ...users,
        ...{
          assignedUsers: {
            values: payload.values,
            count: payload.count,
            page: payload.page,
            total_pages: payload.total_pages,
            query: payload.query,
          },
        },
      };
    case ADD_ADMIN_DASHBOARD_USERS:
      return {
        ...users,
        ...{
          statistics: {
            ...users.statistics,
            ...payload.statistics,
          },
        },
      };
    case ADD_NOVONORDISK_USERS:
      return {
        ...users,
        novonordiskUsers: payload.values,
      };
    case SET_PROFILE_CONFIRMATION:
      return {
        ...users,
        showProfileConfirmation: payload.showProfileConfirmation,
      };
    case ADD_ADMIN_USRES_WEBINARS:
      return {
        ...users,
        adminWebinarRegisteredUsers: payload.values,
      };
    case ADD_ADMIN_USERS_NEWSLETTER_WEBINARS:
      return {
        ...users,
        newsletters: {
          values: payload.values,
          count: payload.count,
          total_pages: payload.total_pages,
        },
      };
    case ADD_ADMIN_USRES_WEBINARS_SESSIONS:
      return {
        ...users,
        sessions: payload.values,
      };
    // case SET_SPONSORS_REPRESENTATIVE: {
    //   return {
    //     ...users,
    //     sponsorRepresantive: {
    //       totalPages: payload.total_pages,
    //       count: payload.count,
    //       data: payload.sponsors,
    //     },
    //   };
    // }
    // case SET_SPONSORS_REPRESENTATIVE_REQUESTS: {
    //   return {
    //     ...users,
    //     sponsorRepresantiveRequests: {
    //       totalPages: payload.total_pages,
    //       count: payload.count,
    //       data: payload.requests,
    //     },
    //   };
    // }
    case ADMIN_SET_CERTIFICATES_USERS: {
      return {
        ...users,
        certificatesUsers: {
          totalPages: payload.total_pages,
          count: payload.count,
          data: payload.users,
        },
      };
    }
    // case CLEAR_SPONSORS_REPRESENTATIVE_REQUESTS: {
    //   return {
    //     ...users,
    //     sponsorRepresantiveRequests: {
    //       totalPages: 0,
    //       count: 0,
    //       data: [],
    //     },
    //   };
    // }
    case ADMIN_CLEAR_CERTIFICATES_USERS: {
      return {
        ...users,
        certificatesUsers: {
          totalPages: 0,
          count: 0,
          data: [],
        },
      };
    }
    case SET_NOTIFICATIONS_INFINITE: {
      return {
        ...users,
        notifications: {
          totalPages: payload.total_pages,
          count: payload.count,
          data: [
            ...(users.notifications ? users.notifications.data : []),
            ...payload.feeds,
          ],
        },
      };
    }
    case SET_NOTIFICATIONS: {
      return {
        ...users,
        notifications: {
          totalPages: payload.total_pages,
          count: payload.count,
          data: payload.feeds,
        },
      };
    }
    case SET_NOTIFICATIONS_COUNT: {
      return {
        ...users,
        notificationsCount: payload,
      };
    }
    case CLEAR_NOTIFICATIONS: {
      return {
        ...users,
        notifications: {
          totalPages: 0,
          count: 0,
          data: [],
        },
      };
    }
    default:
      return users;
  }
};
export { users };



// WEBPACK FOOTER //
// ./src/reducers/users.js